import styled from 'styled-components'

export const InvestmentHeaderWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .saving-card {
    margin-top: 30px;
    width: 320px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.secondPrimary};
    border-radius: 14px;
    color: white;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
  }
  .card-title {
    margin-left: 28px;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: ${({ theme }) => theme.colors.white};
      margin-top: 30px;
    }
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      color: ${({ theme }) => theme.colors.white};
      margin-top: -20px;
    }
  }
  .increase-icon {
    margin-left: 10px;
  }
  .amount {
    display: flex;
    align-items: center;
    /* width: 300px;
    justify-content: space-around; */
    /* background-color: red; */
    .arrow_up {
      /* padding-left: 10px; */
    }
    .total_investment_amount {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xxl};
      letter-spacing: 1px;
      margin: 0 0 0 20px;
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }

    .total_investment_balance {
      font-weight: normal;
      line-height: 18px;
      letter-spacing: 0.77px;
      color: ${({ theme }) => theme.colors.white};
      font-size: ${({ theme }) => theme.fontSize.x2};
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.s};
        line-height: 18px;
      }
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    padding-top: 50px;
  }
  /* .total {
    padding-top: 50px;
  } */
  .words {
    display: flex;
    align-items: center;
  }
  .words h1 {
    padding: 0px 20px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.xl};
      line-height: 31px;
      padding: 0px 10px;
    }
  }
  .hmb {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x1};
      line-height: 31px;
    }
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mb {
    display: none;
  }
  @media (max-width: 1110px) {
    .mb {
      display: flex;
      margin-right: -32px;
    }
    .lg {
      display: none;
    }
  }
`
